import { render, staticRenderFns } from "./Rapporto.vue?vue&type=template&id=725662d0&scoped=true&"
import script from "./Rapporto.vue?vue&type=script&lang=js&"
export * from "./Rapporto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "725662d0",
  null
  
)

export default component.exports